import React from 'react';

export interface TabPaneProps {
  tabKey: string;
  children: React.ReactNode;
}

const TabPane: React.FC<TabPaneProps> = ({ children }) => {
  return <div role="tabpanel">{children}</div>;
};

export default TabPane;
